// Libs
import { createSelector } from 'reselect'
import _find from 'lodash/find'

// Constants
import {
  PROP_ASSET_ID,
} from 'fc-model-assets'

// Selectors
import selectedFieldId$ from './selectedFieldId'
import featureOperation$ from './featureOperation'

import { fields$ } from 'fc-assets'

export default createSelector(
  [fields$, selectedFieldId$, featureOperation$],
  function (fields, selectedFieldId, featureOperation) {
    if (featureOperation) {
      return featureOperation.model
    } else if (selectedFieldId) {
      return _find(fields, { [PROP_ASSET_ID]: selectedFieldId }) || null
    }

    return null
  }
)
